import { NavLink } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const rafRef = useRef(null);

  // Lock scroll when navbar is open on mobile
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const getThrottle = () => (mediaQuery.matches ? 50 : 16);

    const handleScroll = () => {
      if (rafRef.current) {
        return;
      }

      // Use larger throttle on mobile for smoother scroll
      rafRef.current = setTimeout(() => {
        setIsScrolled(window.scrollY > 20);
        rafRef.current = null;
      }, getThrottle()); // 50ms on mobile, 16ms on desktop
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafRef.current) {
        clearTimeout(rafRef.current);
      }
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} aria-label="Main navigation">
      <div className="container">
        <NavLink className="navbar-brand" to="/" onClick={closeMenu}>
          <img src="/img/logo_trace.svg" alt="VW Web Solutions" className="navbar-logo" />
        </NavLink>

        <button
          className="navbar-toggle"
          type="button"
          onClick={toggleMenu}
          aria-expanded={isOpen}
          aria-label="Toggle navigation menu"
        >
          <span className="navbar-toggle-icon"></span>
          <span className="navbar-toggle-icon"></span>
          <span className="navbar-toggle-icon"></span>
        </button>

        <ul className={`navbar-menu${isOpen ? ' active' : ''}`}>
          <li>
            <NavLink to="/" onClick={closeMenu}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={closeMenu}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" onClick={closeMenu}>
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" onClick={closeMenu}>
              Services
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={closeMenu}>
              Contact
            </NavLink>
          </li>
        </ul>

        {/* Overlay for mobile menu */}
        {isOpen && (
          <div className="navbar-overlay" onClick={closeMenu} tabIndex={0} aria-hidden="false" />
        )}
      </div>
    </nav>
  );
}

export default Navbar;
